import {
    apiRequest,
    identitasDetail,
    downloadDRH,
    downloadDRHdoc,
    identitasImages
} from "../../../../../services/adapters/kepegawaian/indentitasService"

class IndexRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", identitasDetail, {
            params: query
        }, true)
    }
    
    fetchDownloadDRH = async (query) => {
        return await apiRequest("get", downloadDRH, {
            params: query
        }, true)
    }
    fetchDownloadDRHdoc = async (query) => {
        return await apiRequest("get", downloadDRHdoc, {
            params: query
        }, true)
    }

    fetchImages = async (query) => {
        return await apiRequest("get", identitasImages, {
            params: query
        }, true)
    }
}

export default IndexRepository